module.exports = __webpack_public_path__ + "media/images/kickstarter/pc-8e0eef0b998a787bbc9cfcfa03a842de.png";